import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  Autocomplete,
  TextField,
} from "@mui/material";
import {
  getDateRange,
  getMonthOptions,
  getYearOptions,
} from "../../../utils/date-utils";

export default function FilterPanel({
  company,
  setCompany,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  companyOptions = [],
}) {
  const monthOptions = getMonthOptions();
  const yearOptions = getYearOptions();

  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();

  // Extract current selection from startDate
  const selectedYear = startDate
    ? startDate.split("-")[0]
    : currentYear.toString();
  const selectedMonthIndex = startDate
    ? parseInt(startDate.split("-")[1], 10) - 1
    : currentMonth;
  const selectedMonth = monthOptions[selectedMonthIndex];

  const handleMonthChange = (month) => {
    const { startDate: newStartDate, endDate: newEndDate } = getDateRange({
      year: selectedYear,
      month,
    });
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  };

  const handleYearChange = (year) => {
    const { startDate: newStartDate, endDate: newEndDate } = getDateRange({
      year,
      month: selectedMonth,
    });
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  };
  return (
    <Box
      sx={{
        mb: 3,
        backgroundColor: "#f8fafc",
        p: { xs: 2, sm: 3 },
        borderRadius: "16px",
        maxWidth: 900,
        mx: "auto",
        boxShadow: "0 2px 8px 0 rgba(0,0,0,0.04)",
      }}
    >
      <Grid container spacing={2} alignItems="center" justifyContent="center">
        <Grid item xs={12} md={4}>
          <FormControl fullWidth size="small">
            <Autocomplete
              options={companyOptions}
              getOptionLabel={(option) => option.label || ""}
              isOptionEqualToValue={(option, value) => option.value === value}
              value={companyOptions.find((o) => o.value === company) || null}
              onChange={(_, newValue) =>
                setCompany(newValue ? newValue.value : "")
              }
              renderInput={(params) => (
                <TextField {...params} label="Company Name" size="small" />
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={4}>
          <FormControl fullWidth size="small">
            <InputLabel>Year</InputLabel>
            <Select
              value={selectedYear}
              label="Year"
              onChange={(e) => handleYearChange(e.target.value)}
            >
              {yearOptions.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={4}>
          <FormControl fullWidth size="small">
            <InputLabel>Month</InputLabel>
            <Select
              value={selectedMonth}
              label="Month"
              onChange={(e) => handleMonthChange(e.target.value)}
            >
              {monthOptions.map((month) => (
                <MenuItem key={month} value={month}>
                  {month}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
}
